var map = {
	"./Logo(en)_Dark.svg": "a057",
	"./Logo(en)_Light.svg": "4384",
	"./Logo(ko)_Dark.svg": "4f3e",
	"./Logo(ko)_Light.svg": "c7cc"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2e54";